import React from "react";
import { Check, Download, FileText, Shield } from "lucide-react";
import { COMPANY_LOGO_URL, COMPANY_NAME } from "../../utils/companyLogo";

const highlights = [
  { icon: FileText, text: "All profile sections included" },
  { icon: Shield, text: "Branded & confidential" },
];

const ProfileDownloadCard = ({ onDownload, downloading }) => (
  <section className="mt-10">
    <div className="relative overflow-hidden rounded-2xl border border-[#E5E7EB] bg-gradient-to-br from-white via-white to-[#EBF5FF] p-1 shadow-md">
      <div className="rounded-[14px] bg-white">
        <div className="grid gap-0 md:grid-cols-5">
          <div className="border-b border-[#E5E7EB] bg-[#000929] p-6 md:col-span-2 md:border-b-0 md:border-r">
            <div className="flex h-full flex-col justify-between gap-6">
              <div>
                <div className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-white p-3 shadow-lg">
                  <img
                    src={COMPANY_LOGO_URL}
                    alt={COMPANY_NAME}
                    className="h-full w-full object-contain"
                  />
                </div>
                <p className="mt-5 text-xs font-semibold uppercase tracking-[0.2em] text-[#097FE6]">
                  {COMPANY_NAME}
                </p>
                <h2 className="mt-2 text-2xl font-bold text-white">
                  Your profile is ready
                </h2>
                <p className="mt-2 text-sm leading-relaxed text-[#9CA3AF]">
                  Every section is complete. Export a professional PDF summary
                  for agents and landlords.
                </p>
              </div>
              <div className="inline-flex w-fit items-center gap-2 rounded-full bg-[#10B981]/15 px-3 py-1.5 text-xs font-semibold text-[#6EE7B7]">
                <Check className="h-4 w-4" strokeWidth={3} />
                100% complete
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-between gap-6 p-6 md:col-span-3">
            <div>
              <p className="text-sm font-semibold text-[#000929]">
                What&apos;s in your PDF
              </p>
              <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3">
                {[
                  "Personal",
                  "About me",
                  "Address",
                  "Employment",
                  "Finances",
                  "ID docs",
                ].map((item) => (
                  <div
                    key={item}
                    className="rounded-xl border border-[#E5E7EB] bg-[#F9FAFB] px-3 py-2.5 text-center text-xs font-medium text-[#374151] shadow-sm"
                  >
                    {item}
                  </div>
                ))}
              </div>
              <ul className="mt-5 space-y-2">
                {highlights.map(({ icon: Icon, text }) => (
                  <li
                    key={text}
                    className="flex items-center gap-2 text-sm text-[#6B7280]"
                  >
                    <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-[#EBF5FF] text-[#097FE6]">
                      <Icon className="h-4 w-4" strokeWidth={2} />
                    </span>
                    {text}
                  </li>
                ))}
              </ul>
            </div>

            <button
              type="button"
              onClick={onDownload}
              disabled={downloading}
              className="inline-flex w-full items-center justify-center gap-2.5 rounded-xl bg-[#097FE6] px-6 py-4 text-sm font-semibold text-white shadow-md transition-all hover:bg-[#0868c4] hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
            >
              <Download className="h-5 w-5" strokeWidth={2} />
              {downloading ? "Generating your PDF…" : "Download PDF"}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ProfileDownloadCard;
